import React from 'react'

interface CalibrationMarkersProps {
  calibrationPoints: {
    heel?: { x: number; y: number; z: number }
    mt1?: { x: number; y: number; z: number }
    mt5?: { x: number; y: number; z: number }
  }
}

export const CalibrationMarkers: React.FC<CalibrationMarkersProps> = ({ calibrationPoints }) => {
  return (
    <group>
      {/* Heel marker - Red */}
      {calibrationPoints.heel && (
        <group position={[calibrationPoints.heel.x, calibrationPoints.heel.y, calibrationPoints.heel.z]}>
          <mesh>
            <sphereGeometry args={[0.15, 16, 16]} />
            <meshBasicMaterial color="#ff0000" transparent opacity={0.8} />
          </mesh>
          {/* Outer glow ring */}
          <mesh>
            <sphereGeometry args={[0.18, 16, 16]} />
            <meshBasicMaterial color="#ff0000" transparent opacity={0.3} wireframe />
          </mesh>
        </group>
      )}

      {/* MT1 marker - Green */}
      {calibrationPoints.mt1 && (
        <group position={[calibrationPoints.mt1.x, calibrationPoints.mt1.y, calibrationPoints.mt1.z]}>
          <mesh>
            <sphereGeometry args={[0.15, 16, 16]} />
            <meshBasicMaterial color="#00ff00" transparent opacity={0.8} />
          </mesh>
          {/* Outer glow ring */}
          <mesh>
            <sphereGeometry args={[0.18, 16, 16]} />
            <meshBasicMaterial color="#00ff00" transparent opacity={0.3} wireframe />
          </mesh>
        </group>
      )}

      {/* MT5 marker - Blue */}
      {calibrationPoints.mt5 && (
        <group position={[calibrationPoints.mt5.x, calibrationPoints.mt5.y, calibrationPoints.mt5.z]}>
          <mesh>
            <sphereGeometry args={[0.15, 16, 16]} />
            <meshBasicMaterial color="#0000ff" transparent opacity={0.8} />
          </mesh>
          {/* Outer glow ring */}
          <mesh>
            <sphereGeometry args={[0.18, 16, 16]} />
            <meshBasicMaterial color="#0000ff" transparent opacity={0.3} wireframe />
          </mesh>
        </group>
      )}
    </group>
  )
}
